import { CSSProperties, Dispatch, FC, SetStateAction } from 'react'

import { useUnit } from 'effector-react'

import { $fanId } from '@/models/chattingUI/chats/chats'
import { useOpenChat } from '@/modules/chatting/hooks/use-open-chat'
import { ChatItem } from '@/modules/chatting/types'

import { FloatingChatInfoConfig } from '.'
import { SwipeableChatItemWithActions } from './swipeable-with-actions'

interface Props {
  data: {
    items: ChatItem[]
    onSelectChat: () => void
    setFloatingChatInfoConfig: Dispatch<
      SetStateAction<FloatingChatInfoConfig | null>
    >
    isExpanded: boolean
    setIndex: (index: number) => void
  }
  index: number
  style: CSSProperties
}

export const ChatItemRow: FC<Props> = ({
  data: {
    onSelectChat,
    setFloatingChatInfoConfig,
    isExpanded,
    items,
    setIndex,
  },
  index,
  style,
}) => {
  const fanId = useUnit($fanId)
  const { handleOpenChat } = useOpenChat()
  const chat = items[index]
  const chatId = chat.id
  const handleClick = () => {
    if (fanId === chatId) {
      return
    }
    onSelectChat()
    handleOpenChat(chatId)
  }

  setIndex(index)

  return (
    <SwipeableChatItemWithActions
      onClick={handleClick}
      onShowFloatingInfo={setFloatingChatInfoConfig}
      isSidebarExpanded={isExpanded}
      chatId={chatId}
      style={style}
    />
  )
}
